import { ref, computed } from 'vue'
import { useStore } from '@freebe/sdk/store'

export default function useClientLogo (userId) {
  const { fetch, get } = useStore('@freebe/users')

  const id = ref(userId?.value || userId)

  const user = computed(() => get(id.value))

  const name = computed(() =>  user.value?.name)
  const logo = computed(() => 
    user.value?.picture
  )

  if (!user.value) {
    fetch(id.value)
  }

  return {
    name,
    logo,
    url: logo,
  }
}